<table class="table table-centered table-nowrap">
    <thead>
        <th *ngIf="reportTypeGrid == 2">{{'Common.ServiceName'|translate}}</th>
        <th *ngIf="reportTypeGrid == 2">{{'Common.ProductId'|translate}}</th>
        <th *ngIf="reportTypeGrid == 2">{{'Common.ProductName'|translate}}</th>
        <th *ngIf="reportTypeGrid == 2">{{'Common.Barcode'|translate}}</th>
        <th>{{'Common.ProviderName'|translate}}</th>
        <th>{{'Common.TotalCost'|translate}}</th>
        <th>{{'Common.TotalSellPrice'|translate}}</th>
        <th>{{'Common.TotalNumber'|translate}}</th>
        <th *ngIf="reportTypeGrid == 1">{{'Common.Total'|translate}}</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of dataSource">
            <td *ngIf="reportTypeGrid == 2">{{ item.BrandName }}</td>
            <td *ngIf="reportTypeGrid == 2">{{ item.ProductId }}</td>
            <td *ngIf="reportTypeGrid == 2">{{ item.ProductName }}</td>
            <td *ngIf="reportTypeGrid == 2">{{ item.Barcode }}</td>
            <td>{{ item.Provider }}</td>
            <td>{{ item.TotalCost }}</td>
            <td>{{ item.TotalSellPrice }}</td>
            <td>{{ item.TotalCount }}</td>
            <td *ngIf="reportTypeGrid == 1">{{ item.InvoiceTotal=='' ? '--' : item.InvoiceTotal }}</td>
        </tr>
    </tbody>
</table>